import { Quote } from '../charts-lib'
import './market_sentiment'
import './refresh'

interface Index {
  ticker: string
  timeframe: string
  volume: number[]
  date: number[]
  open: number[]
  high: number[]
  low: number[]
  close: number[]
  lastOpen: null
  lastHigh: null
  lastLow: null
  lastClose: number
  lastVolume: null
  lastDate: number
  prevClose: number
  afterClose: null
  afterChange: null
  relativeVolume: number
}

export type Indices = Record<string, Index>

export function getData(index: string, ticker: string, indices: Indices) {
  return {
    ...indices[index],
    ticker: ticker, // use text?
    timeframe: 'i10',
    instrument: 'stock',
    premarket: false,
    aftermarket: false,
    afterChange: null,
    afterClose: null,
    drawMinutesPerDay: 390,
    marketStartMinutes: 570,
    premarketLengthMinutes: 0,
    aftermarketLengthMinutes: 0,
  }
}

export function updateIndices(indices: Indices) {
  Quote.findByAttribute('ticker', 'DOW').updateAttributes(getData('^DJI', 'DOW', indices))
  Quote.findByAttribute('ticker', 'NASDAQ').updateAttributes(getData('^IXIC', 'NASDAQ', indices))
  Quote.findByAttribute('ticker', 'S&P 500').updateAttributes(getData('^GSPC', 'S&P 500', indices))
}
